var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEndToEndinline = function SvgEndToEndinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#7D64FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8 11.999a1.2 1.2 0 0 1 1.2-1.2h22a1.2 1.2 0 0 1 1.2 1.2v20a1.2 1.2 0 0 1-1.2 1.2H11a1.2 1.2 0 0 1-1.2-1.2v-20Zm2.4 18.8V16h19.6v14.799H12.2Zm6.134-11.21a.2.2 0 0 0-.245.245l1.872 7.021c.052.192.32.2.383.012l.754-2.26a.2.2 0 0 1 .33-.078l2.83 2.83a.2.2 0 0 0 .283 0l1.318-1.318a.2.2 0 0 0 0-.282l-2.83-2.83a.2.2 0 0 1 .078-.331l2.26-.754c.188-.062.18-.332-.012-.383l-7.021-1.872Z",
    fill: "url(#end-to-end_inline_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "end-to-end_inline_svg__a",
    x1: 22.003,
    y1: 9.246,
    x2: 22.003,
    y2: 33.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#fff",
    stopOpacity: 0.8
  })))));
};
export default SvgEndToEndinline;